import { Image as ExpoImage } from 'expo-image'
import React from 'react'

import type { Image as ImageProps } from '@flows/core/types/stepContentTypes'

export const Image = (props: ImageProps) => {
  // Using 1 allows for the image to be rendered,
  // then the size is updated on fetch when no size is provided
  const [size, setSize] = React.useState({ width: props.width ?? 1, height: props.height ?? 1 })

  return (
    <ExpoImage
      source={props.src}
      contentFit={props.contentFit ?? 'none'}
      contentPosition={props.align ?? 'center'}
      style={{
        width: size.width,
        height: size.height,
        aspectRatio: props.aspectRatio,
        ...(props.align === 'center' && { alignSelf: 'center' as const }),
      }}
      onLoad={(event) => {
        setSize({
          width: props.width ?? event.source.width,
          height: props.height ?? event.source.height,
        })
      }}
    />
  )
}
